import { Controller } from "@hotwired/stimulus"

// Tracks time spent filling out a form for fraud detection purposes.
// Forms filled in under 30 seconds are flagged as potentially suspicious.
export default class extends Controller {
  static targets = ["time"]

  connect() {
    this.startTime = Date.now()
    this.updateTime()

    // Update every second to keep the time accurate
    this.interval = setInterval(() => this.updateTime(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateTime() {
    if (this.hasTimeTarget) {
      const elapsedSeconds = Math.floor((Date.now() - this.startTime) / 1000)
      this.timeTarget.value = elapsedSeconds
    }
  }
}
